import { useState } from 'react';
import ErrorList from '../components/errors/ErrorList';
import ErrorDetail from '../components/errors/ErrorDetail';

export default function ErrorsPage() {
  const [selectedErrorId, setSelectedErrorId] = useState<string | null>(null);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Errors</h1>

      {selectedErrorId ? (
        <ErrorDetail
          errorId={selectedErrorId}
          onBack={() => setSelectedErrorId(null)}
        />
      ) : (
        <ErrorList onSelect={(id) => setSelectedErrorId(id)} />
      )}
    </div>
  );
}
